var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPersonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#999999",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 11.75C15.0376 11.75 17.5 9.28757 17.5 6.25C17.5 3.21243 15.0376 0.75 12 0.75C8.96243 0.75 6.5 3.21243 6.5 6.25C6.5 9.28757 8.96243 11.75 12 11.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.25C6.75581 13.2561 2.50606 17.5058 2.5 22.75C2.5 23.0261 2.72386 23.25 3 23.25H21C21.2761 23.25 21.5 23.0261 21.5 22.75C21.4939 17.5058 17.2442 13.2561 12 13.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonIcon);
export default __webpack_public_path__ + "static/media/person-icon.434a419979731522d7fdf62e9642b425.svg";
export { ForwardRef as ReactComponent };